import { useQuery } from "@tanstack/react-query";
import { PhosphorGearAnchor } from "components/Atoms/PhosphorIconAnchor";
import { ConfigureICalendarTemplateMessageBox } from "components/MessageBox/ConfigureICalendarTemplateMessageBox";
import ICalFeedTemplatePaginatedDropdown from "components/dropdowns/paginated/ICalFeedTemplatePaginatedDropdown";
import { Loading } from "components/panels";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface ICalendarTemplatePickerProps {
  value: server.dto.ICalendarTemplateSmall;
  onChange: (template: server.dto.ICalendarTemplateSmall) => void;
}

export const ICalendarTemplatePicker = (props: ICalendarTemplatePickerProps) => {
  const templatesApi = useQuery({
    queryKey: ["hasIcalTemplates"],
    queryFn: async () => window.CoreApi.ICalendarTemplate.List({ page: 1, perPage: 2 }).then(r => r.data),
    onSuccess: (res) => {
      if (res.data.length > 0) {
        props.onChange(res.data[0]);
      }
    }
  });

  if (templatesApi.isLoading) {
    return <Loading />
  }

  const hasTemplates = templatesApi.data?.pagination.hasResults;

  if (!hasTemplates) {
    return <ConfigureICalendarTemplateMessageBox />
  }

  return <div className="flex gap-small">
    <div className="grow1">
      <ICalFeedTemplatePaginatedDropdown
        value={props.value}
        onChange={props.onChange}
        config={{
          isSearchable: true,
          shouldRenderSelectedValue: true,
        }}
      />
    </div>
    <PhosphorGearAnchor
      href={routes.iCalendarTemplate_List().absolute}
      layout="in-square"
      iconSize="large"
      selectedStyle="green-bg"
    />
  </div>
}